var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.viewsScope ? _c('div', {
    staticClass: "table-views-bar mb-3"
  }, [_c('div', {
    staticClass: "table-views-bar__row d-flex align-center"
  }, [_c('div', {
    staticClass: "table-views-bar__views flex-grow-1 d-flex flex-wrap align-center"
  }, [_vm._l(_vm.views, function (view, index) {
    return _c('v-chip', {
      key: view.id,
      staticClass: "mr-2 my-1",
      attrs: {
        "color": _vm.activeViewId === view.id ? 'primary' : undefined,
        "outlined": _vm.activeViewId !== view.id,
        "close": ""
      },
      on: {
        "click": function click($event) {
          return _vm.applyView(view);
        },
        "click:close": function clickClose($event) {
          return _vm.onChipClose(view);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.viewLabel(view, index)) + " ")]);
  }), _vm.loading ? _c('span', {
    staticClass: "text-caption grey--text my-1 ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$translate("loading")) + " ")]) : !_vm.views.length ? _c('span', {
    staticClass: "text-caption grey--text text--darken-1 my-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("noViews")) + " ")]) : _vm._e()], 2), _vm.showFilterActions ? _c('div', {
    staticClass: "table-views-bar__actions d-flex align-center flex-shrink-0"
  }, [_vm.canReset ? _c('span', {
    staticClass: "link table-views-bar__reset mr-2",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.resetFilters,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.resetFilters.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("resetFilters")) + " ")]) : _vm._e(), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "d-inline-flex"
        }, 'span', attrs, false), on), [_c('v-btn', {
          staticClass: "table-views-bar__save",
          attrs: {
            "icon": "",
            "small": "",
            "color": "primary",
            "loading": _vm.saving,
            "disabled": _vm.saving || !_vm.canSave,
            "aria-label": _vm.$translate('saveFilters')
          },
          on: {
            "click": _vm.onSaveClick
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-save")])], 1)], 1)];
      }
    }], null, false, 1950152158)
  }, [_c('span', [_vm._v(_vm._s(_vm.$translate("saveFilters")))])])], 1) : _vm._e()]), _c('v-dialog', {
    attrs: {
      "max-width": "420",
      "persistent": ""
    },
    model: {
      value: _vm.createDialog,
      callback: function callback($$v) {
        _vm.createDialog = $$v;
      },
      expression: "createDialog"
    }
  }, [_c('v-card', {
    staticClass: "table-views-save-dialog"
  }, [_c('v-card-title', {
    staticClass: "table-views-save-dialog__title"
  }, [_c('div', {
    staticClass: "table-views-save-dialog__title-icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": "22"
    }
  }, [_vm._v("mdi-bookmark-plus-outline")])], 1), _c('div', [_c('div', {
    staticClass: "table-views-save-dialog__heading"
  }, [_vm._v(" " + _vm._s(_vm.$translate("createDialogTitle")) + " ")]), _c('div', {
    staticClass: "table-views-save-dialog__subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$translate("createDialogSubtitle")) + " ")])])]), _c('v-card-text', {
    staticClass: "table-views-save-dialog__body"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$translate('viewNameLabel'),
      "error-messages": _vm.createNameErrors,
      "outlined": "",
      "dense": "",
      "autofocus": "",
      "counter": "128",
      "maxlength": "128",
      "hide-details": "auto"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.confirmCreate.apply(null, arguments);
      }
    },
    model: {
      value: _vm.createName,
      callback: function callback($$v) {
        _vm.createName = $$v;
      },
      expression: "createName"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "table-views-save-dialog__actions"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "px-3",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeCreateDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("cancel")) + " ")]), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.saving,
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.confirmCreate
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("create")) + " ")])], 1)], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }